/**
 * IntelliGems A/B — Product images (PDP multirow "Pain-Free Walking")
 *
 * Control (A):
 *   document.body.setAttribute('data-ig-product-images', 'false');
 *   Shows original comparison image (Design_1_copy / Regular vs Our Shoes).
 *
 * Variant (B):
 *   document.body.setAttribute('data-ig-product-images', 'true');
 *   Replaces that right-side image with product-images-ab-test.mp4.
 *
 * Dev preview: ?product_images_test=b  (or true / 1)
 *
 * Video URL from Liquid:
 *   window.__igProductImagesAB = { videoUrl: "..." }
 */
(function () {
  'use strict';

  if (window.__igProductImagesABInit) return;
  window.__igProductImagesABInit = true;

  var ATTR = 'data-ig-product-images';
  var MARK = 'data-ig-product-images-swapped';
  var VIDEO_CLASS = 'ig-product-images-ab__video';
  var WRAP_CLASS = 'ig-product-images-ab__wrap';
  var HIDDEN_CLASS = 'ig-product-images-ab__hidden';
  var IMAGE_MARKERS = ['Design_1_copy', 'Design_1_copy_07a9e8c3'];
  var HEADING_RE = /pain[\s-]*free/i;

  var applying = false;
  var debounceTimer = null;

  function isTruthy(value) {
    var n = String(value || '')
      .trim()
      .toLowerCase();
    return n === 'true' || n === '1' || n === 'on' || n === 'yes' || n === 'b';
  }

  function getDevEnabled() {
    try {
      return isTruthy(
        new URLSearchParams(window.location.search).get('product_images_test')
      );
    } catch (e) {
      return false;
    }
  }

  function isVariantB() {
    if (getDevEnabled()) return true;
    if (!document.body) return false;
    return isTruthy(document.body.getAttribute(ATTR));
  }

  function applyDevAttr() {
    if (!getDevEnabled() || !document.body) return;
    if (!isTruthy(document.body.getAttribute(ATTR))) {
      document.body.setAttribute(ATTR, 'true');
    }
  }

  function getVideoUrl() {
    var cfg = window.__igProductImagesAB;
    if (cfg && cfg.videoUrl) return String(cfg.videoUrl);
    return '';
  }

  function isProductPage() {
    try {
      if (window._template && window._template.name === 'product') return true;
    } catch (e) {}
    return /\/products\//i.test(window.location.pathname || '');
  }

  function mediaLooksLikeTargetImage(media) {
    if (!media) return false;
    var img = media.querySelector('img');
    if (!img) return false;

    var haystack = [
      img.getAttribute('src') || '',
      img.getAttribute('srcset') || '',
      img.getAttribute('data-src') || '',
      img.getAttribute('data-srcset') || '',
      img.currentSrc || ''
    ].join(' ');

    for (var i = 0; i < IMAGE_MARKERS.length; i++) {
      if (haystack.indexOf(IMAGE_MARKERS[i]) !== -1) return true;
    }
    return false;
  }

  function rowMatchesHeading(row) {
    if (!row) return false;
    var heading = row.querySelector('.image-with-text__heading');
    if (!heading) return false;
    return HEADING_RE.test(heading.textContent || '');
  }

  function findTargetRows() {
    var rows = Array.prototype.slice.call(
      document.querySelectorAll('.multirow .image-with-text, .image-with-text')
    );
    var matches = [];

    rows.forEach(function (row) {
      var media = row.querySelector('.image-with-text__media');
      if (!media) return;
      if (rowMatchesHeading(row) || mediaLooksLikeTargetImage(media)) {
        matches.push({ row: row, media: media });
      }
    });

    return matches;
  }

  function ensureVideo(media, videoUrl) {
    var existing = media.querySelector('.' + VIDEO_CLASS);
    if (existing) return existing;

    var wrap = document.createElement('div');
    wrap.className = WRAP_CLASS;
    wrap.setAttribute(MARK, 'true');

    var video = document.createElement('video');
    video.className = VIDEO_CLASS;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('muted', '');
    video.muted = true;
    video.autoplay = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('preload', 'metadata');
    video.setAttribute('disablepictureinpicture', '');
    video.setAttribute('aria-label', 'ComfoFeet product video');

    var source = document.createElement('source');
    source.src = videoUrl;
    source.type = 'video/mp4';
    video.appendChild(source);

    wrap.appendChild(video);
    media.appendChild(wrap);
    return video;
  }

  function hideOriginalMedia(media) {
    Array.prototype.forEach.call(media.children, function (child) {
      if (child.classList && child.classList.contains(WRAP_CLASS)) return;
      child.classList.add(HIDDEN_CLASS);
      child.setAttribute('data-ig-product-images-orig', '1');
    });
  }

  function showOriginalMedia(media) {
    Array.prototype.forEach.call(
      media.querySelectorAll('[data-ig-product-images-orig="1"]'),
      function (child) {
        child.classList.remove(HIDDEN_CLASS);
        child.removeAttribute('data-ig-product-images-orig');
      }
    );

    var wrap = media.querySelector('.' + WRAP_CLASS);
    if (wrap) wrap.remove();
    media.removeAttribute(MARK);
  }

  function playSafe(video) {
    if (!video) return;
    try {
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    } catch (e) {}
  }

  function applyVariant() {
    if (applying) return;
    applying = true;

    try {
      applyDevAttr();

      if (!isProductPage()) {
        applying = false;
        return;
      }

      var videoUrl = getVideoUrl();
      var targets = findTargetRows();
      var active = isVariantB();

      document.documentElement.classList.toggle('ig-product-images-ab--b', active);
      if (document.body) {
        document.body.classList.toggle('ig-product-images-ab--b', active);
      }

      targets.forEach(function (item) {
        var media = item.media;
        if (!media) return;

        if (!active) {
          showOriginalMedia(media);
          return;
        }

        if (!videoUrl) return;

        hideOriginalMedia(media);
        media.setAttribute(MARK, 'true');
        playSafe(ensureVideo(media, videoUrl));
      });
    } finally {
      applying = false;
    }
  }

  function scheduleApply() {
    window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(applyVariant, 50);
  }

  function boot() {
    applyDevAttr();
    scheduleApply();

    if (document.body) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].attributeName === ATTR) {
            scheduleApply();
            break;
          }
        }
      }).observe(document.body, {
        attributes: true,
        attributeFilter: [ATTR]
      });
    }

    new MutationObserver(function () {
      if (!isVariantB()) return;
      scheduleApply();
    }).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.ComfofeetProductImagesAB = {
    apply: scheduleApply,
    isVariantB: isVariantB
  };
})();
